<template>
  <md-dialog :md-active.sync="showSplashScreen" :md-dynamic-height="true" :md-close-on-esc="false" :md-click-outside-to-close="false" :md-fullscreen="false">
    <md-dialog-title>Welkom bij <strong>The Real You app</strong></md-dialog-title>
    <md-dialog-content>
      <h2 class="md-dialog-title md-dialog-title--small">
        Je kunt gelijk beginnen met het bijhouden van je eetdagboek.
      </h2>
      <div class="o-panels">
        <div class="o-panel">
          <div class="o-panel__content">
            <h3>Account aanmaken</h3>
            <div class="cta">
              <authenticate></authenticate>
            </div>

            <ul>
              <li>
                <md-icon>devices</md-icon>
                <div>
                  Vanaf elk device beschikbaar
                </div>
              </li>
              <li>
                <md-icon>verified_user</md-icon>
                <div>
                  Wij posten nooit iets (namens jou) op jouw google of facebook profiel
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="o-panel">
          <div class="o-panel__content">
            <h3>Verder zonder account</h3>
            <div class="cta">
              <md-button class="md-primary md-raised md-dense" @click="userConsentedCookies">
                <md-icon>person</md-icon>
                Verder zonder account
              </md-button>
            </div>
            <ul>
              <li>
                <md-icon>computer</md-icon>
                <div>
                  alleen lokaal in deze browser beschikbaar
                </div>
              </li>

              <li>
                <md-icon>warning</md-icon>
                <div>
                  Niet aan te raden als je gebruik maakt van een gedeelde computer
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <p>
        <small
          >Deze site maakt gebruik van cookies, deze zijn onmisbaar voor de functionaliteit die wij bieden. Door verder te gaan op deze pagina, ga je akkoord
          met ons <a href="/privacy">Privacy & Cookie beleid</a></small
        >
      </p>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { authUi } from "../init/firebase.init";
import authenticate from "./partials/Authenticate";

export default {
  name: "SplashScreen",
  components: {
    authenticate
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["isKnownUser", "isLoggedIn", "isCookieConsented"]),
    showSplashScreen() {
      const { isLoggedIn, isKnownUser, isCookieConsented } = this; // trigger dependencies
      if (
        this.$route &&
        this.$route.matched &&
        this.$route.matched[0] &&
        this.$route.matched[0].instances.default &&
        typeof this.$route.matched[0].instances.default.disableLoginPopup !== "undefined"
      ) {
        return !this.$route.matched[0].instances.default.disableLoginPopup;
      }
      return authUi.isPendingRedirect() || (isLoggedIn && !isKnownUser && !isCookieConsented);
    }
  },
  methods: {
    userConsentedCookies() {
      this.$store.dispatch("setCookieConsented", true);
    }
  }
};
</script>

<style lang="scss" scoped>
strong {
  color: #3e6168;
  font-family: "Rajdhani", sans-serif;
  font-weight: 500;
}
small {
  display: block;
}

.italic {
  font-style: italic;
}

.cta {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex: 1;
  height: 175px;
  padding: 8px;

  @media (max-width: 600px) {
    height: auto;
    padding-top: 2rem;
  }

  .md-button {
    margin-bottom: 16px;
  }
}

.md-dialog {
  --md-theme-default-primary: #3e6168;
}

.md-dialog-title {
  margin: 1rem 0 1rem 0;
  font-size: 2.8rem;
  line-height: 1;
  font-weight: 300;
  text-align: center;

  @media (max-width: 600px) {
    margin: 0.5rem 0;
    font-size: 1.6rem;
  }

  &--small {
    margin-top: 0;
    padding-top: 0;
    font-size: 1.3rem;
    line-height: 1;

    @media (max-width: 600px) {
      padding-top: 0.5rem;
      font-size: 1rem;
    }
  }
  &--smaller {
    font-size: 1rem;
    font-weight: 300;
  }
}

.md-dialog-content {
  text-align: center;
}
.md-dialog-actions {
  @media (max-width: 600px) {
    padding: 1rem 0;
    box-shadow: 1px 1px 19px rgba(0, 0, 0, 0.4);
  }
  p {
    padding: 0 8px;
  }
}

.o-panels {
  display: flex;

  @media (max-width: 600px) {
    flex-direction: column;
  }
}

.o-panel {
  flex: 0 0 50%;
  @media (max-width: 600px) {
    margin-bottom: 0.5rem;
  }
}
.o-panel__content {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0 8px;
  background-image: linear-gradient(160deg, #b5e0f7, #5fa9d1 100%);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

  .md-icon {
    // color: var(--color-success-2);
    opacity: 0.3;
  }
  .o-panel:last-child & {
    background-image: linear-gradient(160deg, #93b19a, #3e6168 100%);
    .md-icon {
      // color: var(--color-error-2);
    }
    h3 {
      opacity: 0.5;
    }
  }

  h3 {
    // position: absolute;
    // top: 0;
    // left: 50%;
    // width: 100%;
    // transform: translateX(-50%);
    color: rgba(#ffffff, 0.5);
    font-size: 1.6rem;

    @media (max-width: 600px) {
      margin: 0.5rem 0;
      padding: 0 0.5rem;
      font-size: 1.3rem;
    }
  }

  ul {
    margin: 0;
    padding: 0;
    text-align: left;
    font-size: 12px;
    list-style-type: none;
    color: #091c40;
    background-color: #fff;

    @media (max-width: 600px) {
      font-size: 10px;
    }

    li {
      display: flex;
      padding: 8px 16px;
      border-top: 1px solid var(--color-border);

      div {
        padding-left: 16px;
        flex: 1;
      }
    }
  }
}

.mdl-button {
  font-family: "Lato";
}

.md-button {
  min-width: 64px;
  width: 220px;
  max-width: 220px;
  min-height: 40px;
  margin: 0 auto;
  padding: 8px 8px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;

  .md-icon {
    padding-right: 16px;
  }
}
</style>
